import * as React from 'react';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

export const UnstyledButton = ({ text, onClick, loading, disabled }) => {
    return (
        <UnstyledThemeButton
            variant="contained"
            onClick={onClick}
            loading={loading}
            disabled={disabled}
        >
            {text}
        </UnstyledThemeButton>
    );
}

const UnstyledThemeButton = styled(LoadingButton)({
    display: "inherit",
    height: 'inherit',
    width: 'inherit',
    color: "inherit",
    borderRadius: 'inherit',
    backgroundColor: 'inherit',
    fontFamily: "inherit !important",
    fontSize: "inherit",
    '&:hover': {
        backgroundColor: "#0088ff",
    },
});